import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        pDocContainer: {
            gap: {base: remCalc(16), md: remCalc(32), lg: remCalc(73), xl: remCalc(160)},
            alignItems: 'center',
            justifyContent: 'center',
            direction: {base: 'column', md: 'row'},
            py: ['small.base', 'small.sm', 'medium.md', 'medium.lg'],
            textStyle: ['body-medium'],
        },
        pdfTipsStack: {
            justifyContent: 'flex-start',
            alignSelf: {base: 'center', md: 'flex-start'},
            alignItems: 'center',
            gap: remCalc(24),
        },
        pDocDivider: {
            h: {base: remCalc(1), md: remCalc(120)},
            w: {base: '100%', md: remCalc(1)},
            background: 'border.light',
            orientation: {base: 'horizontal', md: 'vertical'},
            m: {base: `${remCalc(20)} 0`, md: `0 ${remCalc(20)}`},
        },
        buttonPadding: {
            fontWeight: 'bold',
            p: 0,
            paddingInline: 0,
            height: 'auto',
        },
        downloadIcon: {
            color: 'background.dark',
            boxSize: ['iconsSize.xlarge'],
        },
        tipIconBox: {
            boxSize: ['iconsSize.medium'],
            p: `${remCalc(2.4)} 0`,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        tipIcon: {
            color: 'icons.background.tertiary',
        },
        tipText: {
            color: 'text.default',
        },
    },
}
